import React, { Component, useState, useEffect } from "react";
import "../index.css";
import "./index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";

const DashboardFooter = () => {
  return (
    <MDBRow
      style={{
        paddingBottom: 40,
        color: "rgb(242, 241, 243)",
        overflowX: "hidden",
        paddingTop: 0,
        borderTop: "0px solid #323033",
        backgroundColor: "transparent",
        width: "100vw",
      }}
      size="12"
      className="d-flex justify-content-center"
    >
      <MDBRow
        style={{ width: "80vw" }}
        className="d-flex justify-content-center"
      >
        <MDBCol className="d-flex justify-content-center" size="12">
          <p
            style={{
              color: "white",
              fontFamily: "CSMedium",
              textAlign: "center",
            }}
          >
            If you have any questions reach me at help@darkgen.app
          </p>
        </MDBCol>
      </MDBRow>
    </MDBRow>
  );
};

export default withRouter(DashboardFooter);
